module.exports = __webpack_public_path__ + "img/fensi.3fed40b5.png";